export default "__VITE_ASSET__dr9wlvSh__"